import React from "react";
import SectionView from "./SectionView"; // We will create this component next
import "../styles/TermsAndConditionsView.css";

const TermsAndConditionsView = () => {
  const date = "September 26, 2023";

  return (
    <main className="legal-view">
      <h1>
        Terms and Conditions
      </h1>
      <p>
        Welcome to Craft: The Social Beer App, a social media platform dedicated
        to beer enthusiasts. Please read these terms and conditions carefully
        before using our services.
      </p>

      {/* Repeat for each SectionView */}
      <SectionView number="1" title="Acceptance of Terms">
        <p>
          By using our App, you acknowledge that you have read, understood, and
          agree to these Terms, as well as our Privacy Policy. You must be at
          least 21 years old to use this App.
        </p>
      </SectionView>

      <SectionView number="2" title="User Registration">
        <p>
          To access certain features of our App, you may be required to register
          an account. You agree to provide accurate and complete information
          during the registration process and to update this information to keep
          it accurate and current.
        </p>
      </SectionView>

      <SectionView number="3" title="User Content">
        <ul>
          <li>
            <strong>a. Posting Content</strong>
            <p>
              Users may post text, photos, videos, and other content ("User
              Content") on the App. You are solely responsible for the User
              Content you post, and you agree not to post any content that is
              illegal, obscene, defamatory, or violates the rights of others.
            </p>
          </li>
          <li>
            <strong>b. Rights to User Content</strong>
            <p>
              By posting User Content, you grant us a non-exclusive, worldwide,
              royalty-free license to use, display, and distribute your content
              in connection with the App.
            </p>
          </li>
          <li>
            <strong>c. Content Moderation</strong>
            <p>
              We reserve the right to remove or moderate any User Content that
              violates these Terms or our content guidelines.
            </p>
          </li>
        </ul>
      </SectionView>

      <SectionView number="4" title="Trademarks">
        <ul>
          <li>
            <strong>a. Disclaimer: Ownership of Beer Labels and Logos</strong>
            <p>
              This mobile application ("App") Craft: The Social Beer App
              contains images and representations of beer labels, beer logos,
              and related visual content for informational and entertainment
              purposes. We want to make it clear that we do not own, nor do we
              claim ownership of any beer labels, beer logos, or the
              intellectual property associated with them, including trademarks
              and copyrights.
            </p>
            <p>
              All beer labels and logos featured in this App are the property of
              their respective breweries, manufacturers, or rights holders. Any
              use of these images and representations is solely for reference
              and descriptive purposes, without any intention of infringing upon
              the rights of the respective owners.
            </p>
            <p>
              If you are a copyright or trademark owner and believe that your
              intellectual property rights have been violated by the use of any
              beer label or logo within this App, please contact us immediately
              so that we can address the issue appropriately.
            </p>
            <p>
              We encourage all users of this App to respect the intellectual
              property rights of others and to use the information and images
              provided herein responsibly and within the boundaries of the law.
            </p>
          </li>
          <li>
            <strong>b. Trademarks</strong>
            <p>
              All trademarks, service marks, and trade names used in the App are
              the property of their respective owners.
            </p>
          </li>
        </ul>
      </SectionView>

      <SectionView number="5" title="Prohibited Activities">
        <p>You agree not to:</p>
        <ul>
          <li>Use the App for any illegal or unauthorized purpose.</li>
          <li>Harass, threaten, or harm other users.</li>
          <li>Interfere with the proper functioning of the App.</li>
          <li>
            Access or use the App in any way that could damage, disable,
            overburden, or impair our servers or networks.
          </li>
        </ul>
      </SectionView>

      <SectionView number="6" title="Termination">
        <p>
          We reserve the right to terminate or suspend your account and access
          to the App for violations of these Terms or for any other reason
          without notice.
        </p>
      </SectionView>

      <SectionView number="7" title="Changes to Terms">
        <p>
          We may update these Terms from time to time. You will be notified of
          any material changes, and continued use of the App after such changes
          constitutes your acceptance of the revised Terms.
        </p>
      </SectionView>

      <SectionView number="8" title="Disclaimer of Warranties">
        <p>
          We provide the App "as is" and make no warranties or representations
          regarding its accuracy or reliability. We are not responsible for any
          content posted by users.
        </p>
      </SectionView>

      <SectionView number="9" title="Limitation of Liability">
        <p>
          We shall not be liable for any direct, indirect, incidental, special,
          or consequential damages arising out of your use of the App.
        </p>
      </SectionView>

      <SectionView number="10" title="Governing Law">
        <p>
          These Terms are governed by the laws of the United States of America.
          Any disputes shall be resolved in the courts of the United States.
        </p>
        <p>
          If you access or use this App from outside the United States, you do
          so at your own risk and are responsible for compliance with the laws
          of your jurisdiction.
        </p>
      </SectionView>

      <h2>11. Contact Information</h2>
      <p>
        If you have any questions or concerns about these Terms, please contact
        us at Craftbeerapp@gmail.com.
      </p>

      <p style={{ fontStyle: "italic" }}>
        By using our App, you agree to these Terms and acknowledge that you have
        the legal capacity to enter into this agreement.
      </p>

      <p style={{ fontStyle: "italic" }}>
        Thank you for your understanding, and enjoy using our App responsibly.
      </p>

      <h1>
        Craft: The Social Beer App
      </h1>
      <p>Last updated: {date}</p>
    </main>
  );
};

export default TermsAndConditionsView;
